const MENU_WIDTH = 215;
const MENU_SELECT_HEIGHT = 30;
const MENU_SELECT_INPUT_HEIGHT = 22;

export { MENU_WIDTH, MENU_SELECT_HEIGHT, MENU_SELECT_INPUT_HEIGHT };
